// src/routes/ProtectedRoute.jsx
import { useEffect, useState } from 'react';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import { authClient } from '../apis/client-instances';
import { Box, CircularProgress } from '../components/ui';
const ProtectedRoute = () => {
  const [loading, setLoading] = useState(true);
  const [authorized, setAuthorized] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const verifySession = async () => {
      try {
        const token = localStorage.getItem('token');
        console.log('token:', token);
        if (!token) {
          setAuthorized(false);
          setLoading(false);
          return;
        }

        await authClient.checkSession();
        console.log('Session verified');
        setAuthorized(true);
      } catch (err) {
        console.error('Session check failed:', err);
        navigate('/signin');
        setAuthorized(false);
      } finally {
        setLoading(false);
      }
    };

    verifySession();
  }, []);

  if (!loading && !authorized) {
    return <Navigate to="/signin" replace />;
  }

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 10 }}>
        <CircularProgress />
      </Box>
    );
  }

  return <Outlet />;
};

export default ProtectedRoute;
